import i18n from './i18n';
import lodashGet from 'lodash/get';
import {USER_PROJECT_STATUSES} from '../constants/user';

export const findProjectMemberInOxygenMappingById = (oxygenId, oxygenMapping) =>
  oxygenMapping.users[oxygenId] || oxygenMapping.companies[oxygenId] || oxygenMapping.roles[oxygenId];

// Returns former user name with "(former user)" appended
const getFormerUserDisplayNameById = (id, deletedUsers, fallBackName) => {
  const formerUser = deletedUsers?.find(user => user.autodeskId === id);
  return formerUser ? `${formerUser.name} (${i18n.t('activity.formerUser')})` : fallBackName;
};

export const getEntityNameByIdHelper = (
  oxygen,
  deletedUsers,
  id,
  fallBackName = i18n.t('activity.formerUser'),
  emptyIdFallback = i18n.t('assignment.assigneeUnspecified')
) => {
  // In case there is no id it should be unspecified
  if (!id) {
    return emptyIdFallback;
  }
  const entity = findProjectMemberInOxygenMappingById(id, oxygen);
  return entity ? entity.name : getFormerUserDisplayNameById(id, deletedUsers, fallBackName);
};

export const getUserNameWithCompanyHelper = (
  oxygen,
  deletedUsers,
  userId,
  fallBackName = i18n.t('assignment.assigneeDeleted'),
  emptyIdFallback = i18n.t('assignment.assigneeUnspecified')
) => {
  if (!userId) {
    return emptyIdFallback;
  }
  const user = findProjectMemberInOxygenMappingById(userId, oxygen);

  if (user) {
    const userCompanyDisplayName = lodashGet(user, 'company.name');

    return userCompanyDisplayName ? `${user.name} (${userCompanyDisplayName})` : user.name;
  }
  return getFormerUserDisplayNameById(userId, deletedUsers, fallBackName);
};

export const getCompanyDisplayName = (oxygen, userId) => {
  const user = lodashGet(oxygen, `users[${userId}]`);
  return lodashGet(user ?? {}, 'company.name');
};

// Don't break if using apps don't pass `projectStatus` as part of the user's data (keep old behaviour of showing all users in that case)
export const isUserAllowed = user =>
  !!user &&
  !!(
    !user.projectStatus ||
    user.projectStatus === USER_PROJECT_STATUSES.ACTIVE ||
    user.projectStatus === USER_PROJECT_STATUSES.PENDING ||
    user.projectStatus === USER_PROJECT_STATUSES.DISABLED
  );

export const isUserActive = user =>
  !!(
    !user.projectStatus ||
    user.projectStatus === USER_PROJECT_STATUSES.ACTIVE ||
    user.projectStatus === USER_PROJECT_STATUSES.PENDING
  );

export const buildProjectUsersArray = users =>
  // Filter users with no  name - as current user have nothing to do with them.
  Object.values(users).filter(user => isUserAllowed(user) && user.name);

export const parseUserObjectForCommentComponent = user =>
  Object.assign({}, user, {
    avatar: user.profileImg50,
    hasAvatar: user.profileImg50 && !user.profileImg50.endsWith('user_X50.png')
  });

export const getUserCompanyName = user => lodashGet(user, 'company.name', '');
